import type { RegistryWidgetsType } from "@rjsf/utils";
import { MultiSelect, MultiSelectWithFilters } from "./MultiSelect";
import { RadioGroup } from "./RadioGroup";
import { SingleSelect } from "./SingleSelect";
import { TextArea } from "./TextArea";
import {
	AerTextInput,
	EmailInput,
	NumberInput,
	PhoneNumberInput,
} from "./TextInput";

import { InformationBox } from "../InformationBox";
import { CheckboxGroup } from "./CheckboxGroup";

// This is the registry of widgets that will be used by the form
const widgets: RegistryWidgetsType = {
	TextInput: AerTextInput,
	SingleSelect: SingleSelect,
	MultiSelect: MultiSelect,
	MultiSelectWithFilters,
	RadioGroup: RadioGroup,
	TextArea: TextArea,
	EmailInput: EmailInput,
	PhoneNumberInput: PhoneNumberInput,
	Information: InformationBox,
	CheckboxGroup: CheckboxGroup,
	NumberInput: NumberInput,
};

export default widgets;
